<template>
  <div class="c-reset_name_form">
    <CustomForm
      ref="resetNameForm"
      :form-data="ruleFormData"
      :model="formModelData"
      class="form"
      :label-width="`0`"
    >
      <template #content>
        <CustomInput
          :value.sync="formModelData.content"
          placeholder="请输入名称"
          :maxlength="maxlength"
          :showWordLimit="true"
        ></CustomInput>
      </template>
    </CustomForm>
  </div>
</template>

<script>
import CustomForm from "@/components/aiChat/components/customForm/index.vue";
import CustomInput from "@/components/aiChat/components/customInput/index.vue";

export default {
  components: {
    CustomForm,
    CustomInput
  },
  props: {
    formModelDataProp: {
      type: Object,
      default() {
        return {};
      },
    },
    maxlength:{
      type: Number,
      default:20
    }
  },
  data() {
    return {
      ruleFormData: [
        {
          label: " ",
          prop: "content",
          rules: [
            {
              validator: (rule, value, callback) => {
                if (this.formModelData.content) {
                  if (this.formModelData.content.length > 20) {
                    return callback(new Error("名称不能超过20个字符"));
                  } else {
                    return callback();
                  }
                } else {
                  return callback(new Error("请输入名称"));
                }
              },
            },
          ],
        },
      ],
      formModelData: {
        id: null,
        content: "",
      },
    };
  },
  methods: {
    onSubmit() {
      return new Promise((resolve, reject) => {
        this.$refs.resetNameForm.onSubmit(
          (y) => {
            if (!this.formModelData.content) {
              this.$message.error("请输入名称");
              resolve(0);
              return;
            }
            resolve(y);
          },
          null,
          () => {
            resolve(0);
          }
        );
      });
    },
  },
  watch: {
    formModelDataProp: {
      handler: function (n) {
        if (n && Object.keys(n).length) {
          console.log(n, "formModelDataProp");
          for (const key in n) {
            if (Object.hasOwnProperty.call(n, key)) {
              const e = n[key];
              for (const t in this.formModelData) {
                if (Object.hasOwnProperty.call(this.formModelData, t)) {
                  if (t == key) {
                    this.formModelData[key] = e;
                  }
                }
              }
            }
          }
        }
      },
      immediate: true,
    },
    "formModelData.content": {
      handler: function (n) {
        if (n) {
          this.$emit("on-change-disabled", false);
        } else {
          this.$emit("on-change-disabled", true);
        }
      },
      immediate: true,
    },
  },
};
</script>

<style lang="scss" scoped>
.c-reset_name_form {
  .form {
    padding-bottom: 24px;
    ::v-deep .content_item {
      .el-form-item__label {
        display: none;
      }
    }
  }
}
</style>